import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ITag, ITagGroup} from 'modules/products/types';
import {useCatalogRoutes} from 'core/modules/routing/hooks/useCatalogRoutes';
import Link, {LINK_THEME} from 'components/Link';
import classNames from 'classnames';
import {useEffect, useRef, useState} from 'react';
import {useIsMobileByScreen} from 'core/hooks/useIsMobileByScreen';
import {capitalizeFirstChar} from 'core/helpers/string';

interface ITagListProps {
    tags: ITag[];
    groupCode: ITagGroup['code'];
}

export const TagList = ({tags, groupCode}: ITagListProps) => {
    const {
        wine: {url},
    } = useCatalogRoutes();

    const path = url();

    const isMobile = useIsMobileByScreen();

    const [needExpand, setNeedExpand] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [contentHeight, setContentHeight] = useState(0);

    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            // @ts-expect-error
            const fullHeight = contentRef.current.scrollHeight;
            setContentHeight(fullHeight);
            if (32 + 32 + 32 / 2 < fullHeight) {
                setNeedExpand(true);
            }
        }
    }, [tags]);

    const collapsedHeight = isMobile ? 112 : 76;

    return (
        <>
            <div
                ref={contentRef}
                className={classNames(style.tags, {
                    [style.expanded]: isExpanded || !needExpand,
                })}
                style={{
                    maxHeight:
                        // eslint-disable-next-line no-nested-ternary
                        isExpanded || !needExpand
                            ? 0 < contentHeight
                                ? `${contentHeight}px`
                                : 'none'
                            : `${collapsedHeight}px`,
                    overflow: 'hidden',
                    transition: 'max-height 200ms ease-in',
                }}
            >
                {tags?.map?.((tag) => (
                    <Link
                        className={style.tag}
                        key={tag.title}
                        theme={LINK_THEME.black}
                        href={'seoTagsLink' !== groupCode ? `${path}/filter/${groupCode}-${tag.code}` : tag.code}
                        title={tag.title}
                    >
                        <Typography data-skeleton-item={true} variant={'label-14-r'}>
                            {capitalizeFirstChar(tag.title)}
                        </Typography>
                    </Link>
                ))}
                <div className={style.expandBg} onClick={() => setIsExpanded(true)} />
            </div>
            {!isExpanded && needExpand && (
                <Typography
                    className={style.expand}
                    variant={'label-12-r'}
                    color={'gray60'}
                    onClick={() => setIsExpanded(true)}
                >
                    Развернуть
                </Typography>
            )}
        </>
    );
};
